import { GetServerSideProps, InferGetServerSidePropsType } from 'next'
import { DefaultHead } from '@/components/common/Head'
import { css } from '@emotion/react'
import { useEffect } from 'react'
import { fetchCommmuneJwt } from '@/lib/api/commmune'
import { useUser } from '../../../contexts/AuthContext'
import { isEnterprise, isGuest, isLoggedIn } from '@/lib/user'
import { useRouter } from 'next/router'
import Error from '../../_error'

type Props = {
  redirectTo?: string
}

const CommmuneSSOBrigdePage: React.FC<
  InferGetServerSidePropsType<typeof getServerSideProps>
> = (props) => {
  const user = useUser()
  const router = useRouter()
  const redirectTo = props.redirectTo

  useEffect(() => {
    // Userの取得が終わるまで待つ
    const timer = setTimeout(() => {
      if (isGuest(user)) router.push('/sso/login')
      if (isEnterprise(user)) {
        fetchCommmuneJwt().then((jwt) => {
          if (jwt) {
            const baseUrl = `${process.env.COMMMUNE_ENDPOINT}/sso/signin?jwtToken=${jwt.jwtToken}`
            window.location.replace(
              redirectTo ? `${baseUrl}&r=${redirectTo}` : baseUrl
            )
          } else {
            router.push('/404')
          }
        })
      }
    }, 1000)
    return () => clearTimeout(timer)
  }, [user, redirectTo, router])

  if (!isLoggedIn(user)) return null
  if (!isEnterprise(user)) return <Error statusCode={404} />

  return (
    <>
      <DefaultHead>
        <meta name="robots" content="noindex" />
      </DefaultHead>
      <main
        css={css`
          height: 100vh;
          display: grid;
          place-items: center;
        `}
      >
        ログインします
      </main>
    </>
  )
}

export const getServerSideProps: GetServerSideProps<Props> = async (ctx) => {
  if (ctx.query.r) {
    return {
      props: { redirectTo: ctx.query.r as string },
    }
  }
  return { props: {} }
}

export default CommmuneSSOBrigdePage
